import { render, staticRenderFns } from "./phonemodel.vue?vue&type=template&id=63be8ceb&scoped=true&"
import script from "./phonemodel.vue?vue&type=script&lang=js&"
export * from "./phonemodel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63be8ceb",
  null
  
)

export default component.exports